/* eslint-disable @typescript-eslint/no-explicit-any */

import { PropsWithChildren } from 'react';

import Content, {
  Default as DefaultContent,
  CardContent,
  LegalContent,
  FAQContent,
  TableContent,
} from './styles';

interface TextProps {
  as?: string;
  size?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: any;
  p?: string;
  py?: string;
  px?: string;
  pb?: string;
  m?: string;
  my?: string;
  mx?: string;
  mb?: string;
  maxWidth?: string;
  color?: string;
  noMargin?: boolean;
}

const Text = ({
  as,
  children,
  size,
  fontSize,
  fontWeight,
  lineHeight,
  p,
  py,
  px,
  pb,
  m,
  my,
  mx,
  mb,
  maxWidth,
  color,
  noMargin,
  ...other
}: PropsWithChildren<TextProps>) => (
  <Content
    as={as}
    size={size}
    className={size}
    p={p}
    py={py}
    px={px}
    pb={pb}
    m={m}
    my={my}
    mx={mx}
    mb={mb}
    maxWidth={maxWidth}
    fontSize={fontSize}
    fontWeight={fontWeight}
    lineHeight={lineHeight}
    noMargin={noMargin}
    color={color}
    {...other}
  >
    {children}
  </Content>
);

export default Text;

export const Default = (props: any) => <Text {...props} as={DefaultContent} />;

export const Card = (props: any) => <Text {...props} as={CardContent} />;

export const Legal = (props: any) => <Text {...props} as={LegalContent} />;

export const FAQ = (props: any) => <Text {...props} as={FAQContent} />;

export const Table = (props: any) => <Text {...props} as={TableContent} />;
